import Link from 'next/link';
import Image from 'next/image';

import { ExpandableMenuItem } from '@/types/menu';
// import Card from './card';
import { useEffect, useState } from 'react';
import { useClickOutside } from '@/hooks/useClickOutside';
import clsx from 'clsx';
import CardStatic from './card-static';

type SubNavItemProps = {
  menuData: ExpandableMenuItem;
  top: number;
  onHide: () => void;
};

export default function SubNavItem({ menuData, top, onHide }: SubNavItemProps) {
  const [itemHovered, setItemHovered] = useState(-1);
  const [isLeaving, setIsLeaving] = useState(false);
  const [visibleIndex, setVisibleIndex] = useState(-1);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (itemHovered !== visibleIndex) {
      setFadeOut(true);
      const timeout = setTimeout(() => {
        setVisibleIndex(itemHovered);
        setFadeOut(false);
      }, 150);
      return () => clearTimeout(timeout);
    }
  }, [itemHovered, visibleIndex]);

  const ref = useClickOutside<HTMLDivElement>(() => setIsLeaving(true));

  useEffect(() => {
    if (isLeaving) {
      const timeout = setTimeout(() => {
        onHide();
      }, 250);

      return () => clearTimeout(timeout);
    }
  }, [isLeaving, onHide]);

  return (
    <div
      ref={ref}
      className={clsx(
        'absolute left-0 right-0 z-40 max-w-7xl mx-auto',
        'flex justify-around gap-2 bg-bluecaixa',
        isLeaving ? 'animate-fadeOut' : 'animate-fadeIn',
        `top-${top}`
      )}
    >
      <div className="flex-3 w-full justify-around flex gap-6 p-8 pl-12">
        <ul className="flex-2 space-y-2 w-full px-4">
          {menuData.services.map((item, index) => {
            return (
              <li key={item.label} className="border-b border-bluecaixa pb-2">
                <button
                  onMouseOver={() => {
                    setItemHovered(index);
                  }}
                  onClick={() => {
                    setItemHovered(index);
                  }}
                  key={item.label}
                  className={`flex items-center bg-transparent shadow-none gap-2 text-sm font-medium ${itemHovered === index ? 'text-orangecaixa' : 'text-white'}`}
                >
                  <Image
                    height={24}
                    width={24}
                    src={`${itemHovered === index ? '/icons/arrow-right-circle-orange.png' : '/icons/arrow-right-circle.png'}`}
                    alt={'right arrow icon'}
                  />
                  {item.label}
                </button>
              </li>
            );
          })}
        </ul>

        <ul
          className={clsx(
            'flex-2 w-full space-y-2 px-4 transition-opacity duration-150',
            visibleIndex === -1 ? 'hidden' : '',
            fadeOut ? 'opacity-0' : 'opacity-100'
          )}
        >
          {visibleIndex !== -1 &&
            menuData.services[visibleIndex].instructions.map((item) => (
              <li key={item.label} className="border-b border-[#0077C7] pb-2">
                <Link
                  href={item.href ?? '#'}
                  className="flex items-center gap-2 text-sm font-medium text-white hover:text-stone-200"
                >
                  <Image
                    height={24}
                    width={24}
                    src="/icons/arrow-right-circle.png"
                    alt="right arrow icon"
                  />
                  {item.label}
                </Link>
              </li>
            ))}
        </ul>
      </div>

      <div className="flex-3 w-full p-8 pl-0">
        <div
          className={clsx(
            'justify-center transition-opacity duration-150',
            visibleIndex === -1 ? 'invisible' : '',
            fadeOut ? 'opacity-0' : 'opacity-100'
          )}
        >
          {/* <Card
            cardInfo={
              menuData.services[itemHovered != -1 ? itemHovered : 0].cardInfo
            }
          /> */}
          {menuData.services[itemHovered != -1 ? itemHovered : 0].cardInfo && (
            <CardStatic
              imgSrc={
                menuData.services[itemHovered != -1 ? itemHovered : 0].cardInfo
                  ?.imgSrc ?? ''
              }
              href={
                menuData.services[itemHovered != -1 ? itemHovered : 0].cardInfo
                  ?.href ?? ''
              }
            />
          )}
        </div>
      </div>
    </div>
  );
}
